export default __webpack_public_path__ + "static/media/kitchen.a978a519.jpg";